<script setup lang="ts">
const { title } = defineProps<{
  title?: string;
}>();
</script>

<template>
  <div class="form-section">
    <h3 v-if="title" class="form-section__title">
      {{ title }}
    </h3>
    <div class="form-section__content">
      <slot />
    </div>
  </div>
</template>

<style scoped lang="scss">
.form-section {
  margin-block: var(--form-section-margin, 36px);

  &__title {
    margin-block: var(--form-section-title-margin, 8px);
    font-size: var(--form-section-title-font-size, 1.5rem);
    line-height: normal;
  }

  :deep(.form-row:first-child) {
    margin-block-start: 0;
  }

  :deep(.form-row:last-child) {
    margin-block-end: 0;
  }
}
</style>
